import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function TimerSkeleton() {
  return (
    <div className="min-h-screen bg-background pb-20 p-4 pt-safe">
      <div className="max-w-md lg:max-w-2xl xl:max-w-4xl mx-auto space-y-5 sm:space-y-6 lg:space-y-8">
        {/* Header with avatar and streak */}
        <div className="flex items-center justify-between pt-4 pb-3">
          <div className="flex items-center gap-3">
            <Skeleton className="w-14 h-14 rounded-full" />
            <div className="flex items-center gap-2">
              <Skeleton className="w-4 h-4 rounded" />
              <Skeleton className="h-5 w-28" />
            </div>
          </div>
          <Skeleton className="h-8 w-24 rounded-full" />
        </div>

        {/* Custom Timer Section */}
        <Card className="p-6 shadow-card">
          <Skeleton className="h-5 w-32 mb-4" />
          <div className="flex items-center gap-4">
            <Skeleton className="h-12 flex-1 rounded-lg" />
            <Skeleton className="h-12 w-20 rounded-lg" />
          </div>
        </Card>

        {/* Category Selector */}
        <Card className="p-6 shadow-card">
          <div className="flex items-center gap-2 mb-3">
            <Skeleton className="w-4 h-4 rounded" />
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
          <Skeleton className="h-11 w-full rounded-lg" />
          <div className="flex items-start gap-2 mt-3">
            <Skeleton className="w-3.5 h-3.5 rounded" />
            <Skeleton className="h-3 w-full" />
          </div>
        </Card>

        {/* Main Timer Card */}
        <Card className="p-8 sm:p-10 lg:p-12 xl:p-16 shadow-xl">
          <div className="text-center mb-8">
            {/* Large time display */}
            <Skeleton className="h-24 sm:h-28 lg:h-32 w-full max-w-md mx-auto mb-6 rounded-xl" />
            
            {/* Progress bars */}
            <div className="space-y-3">
              <div>
                <div className="flex justify-between mb-1">
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-3 w-10" />
                </div>
                <Skeleton className="h-3 w-full rounded-full" />
              </div>
              <div>
                <div className="flex justify-between mb-1">
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-3 w-24" />
                </div>
                <Skeleton className="h-3 w-full rounded-full" />
              </div>
            </div>
          </div>

          {/* Control Buttons */}
          <div className="flex justify-center items-center gap-6">
            <Skeleton className="w-24 h-24 lg:w-32 lg:h-32 rounded-full" />
            <Skeleton className="w-20 h-20 rounded-full" />
          </div>
        </Card>

        {/* Star Display */}
        <div className="flex justify-center">
          <Skeleton className="h-12 w-full max-w-md rounded-lg" />
        </div>

        {/* Session & Daily Stats */}
        <Card className="p-4 lg:p-6 shadow-card">
          <div className="grid grid-cols-2 gap-4 lg:gap-8">
            <div className="text-center space-y-2">
              <Skeleton className="h-4 w-24 mx-auto" />
              <Skeleton className="h-6 w-12 mx-auto" />
            </div>
            <div className="text-center space-y-2">
              <Skeleton className="h-4 w-24 mx-auto" />
              <Skeleton className="h-6 w-20 mx-auto" />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
